// extracted by mini-css-extract-plugin
module.exports = {"root":"root--9nqIe","logo":"logo--6EebH","content":"content--569n7","widthContainer":"widthContainer--htWCa","header":"header--kzEBY","footer":"footer--bGWhH"};